<template>
    <jobs/>
</template>

<script>
import Jobs from "./components/Jobs";

export default {
  components: {
    Jobs
  }
};
</script>